import axios from '../utils/axios';

export function getUnmappedPaidRecruiters(adminId, params) {
    return axios.get(`/admin/${adminId}/unmapped-paid-recs`, { params });
};
